import React from "react";
import { Jumbotron, Container } from "react-bootstrap";

const NotFound = () => {
  return (
    <Jumbotron as={Container} className="bg-white">
      <h1>Error 404</h1>
      <p>We are sorry but the page you are looking for does not exist</p>
    </Jumbotron>
  );
};

export default NotFound;
